import { Button, Card, Col, Dropdown, Input, notification, Row } from "antd";
import React, { useEffect, useState } from "react";
import { withRouter } from "../../../utils/tms-with-router/tms-with-router";
import "../../../assets/css/tms-darshanam/tms-d-inner-pages-and.scss";
import catchErrorFunction from "../../../utils/tms-catch-error/tms-catch-error";
import VehicleServices from "../../../services/vehicle.services";
import Panel from "rc-color-picker/lib/Panel";

const TmsAddCategory = ({
  viewAddCategoryData,
  editFlag,
  productId,
  setEditFlag,
  settmsModalVisible,
  fetchCategories,
  router,
}) => {
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [colorCode, setColorCode] = useState("");

  const handleSubmit = async () => {
    setLoading(true);
    if (name === "" || colorCode === "") {
      notification.error({ message: "Please enter all the details" });
      setLoading(false);
      return;
    }

    try {
      let body = {
        categoryName: name,
        colorCode: colorCode,
      };

      if (editFlag) {
        await VehicleServices.updateCategoryById(productId, body);
        notification.success({ message: "Category Edited Successful" });
        setEditFlag(false);
      } else {
        await VehicleServices.createCategory(body);
        notification.success({ message: "Category Created Successful" });
        handleFuction();
      }
      setLoading(false);
    } catch (error) {
      catchErrorFunction(
        error,
        "Token Expired, redirecting to login page in 5 seconds",
        router
      );
      setLoading(false);
    }
  };

  const overlay = (
    <div>
      <Panel
        color={`#${colorCode}`}
        enableAlpha={false}
        onChange={(e) => {
          setColorCode(e.color?.replaceAll("#", ""));
        }}
      />
    </div>
  );

  const handleFuction = () => {
    setName("");
    setColorCode("");
    fetchCategories();
  };

  useEffect(() => {
    if (editFlag) {
      setName(viewAddCategoryData?.categoryName);
      setColorCode(viewAddCategoryData?.colorCode);
    }
  }, [viewAddCategoryData]);

  return (
    <Row className="formRow" style={{ width: "100%" }}>
      <Card style={{ width: "100%" }}>
        <Row className="formRow">
          <label className="formLabel">Name</label>
          <Input
            maxLength={220}
            className="formInput"
            type="text"
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
        </Row>
        <Row className="formRow">
          <label className="formLabel">Color Code</label>{" "}
          <Input
            value={colorCode || ""}
            className="formInput"
            maxLength={220}
            onChange={(e) => {
              if (e.target.value.includes("#")) {
                return;
              }
              setColorCode(e.target.value);
            }}
            suffix={
              <Dropdown trigger={["click"]} overlay={overlay}>
                <Button style={{ background: `#${colorCode}` }}> </Button>
              </Dropdown>
            }
          />{" "}
        </Row>

        <Row gutter={[20, 20]}>
          <Col span={5}></Col>
          <Col className="formCols-2 buttonPad">
            <Button
              className="formButton"
              type="primary"
              ghost
              loading={loading}
              onClick={() => {
                editFlag ? settmsModalVisible(false) : handleFuction();
              }}
            >
              {editFlag ? "Return" : "Clear"}
            </Button>
          </Col>
          <Col className="formCols-2 buttonPad">
            <Button
              className="formButton"
              type="primary"
              loading={loading}
              onClick={() => {
                handleSubmit();
              }}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Card>
    </Row>
  );
};

export default withRouter(TmsAddCategory);
